import { render, staticRenderFns } from "./select_course.vue?vue&type=template&id=197c7cfe&scoped=true&"
import script from "./select_course.vue?vue&type=script&lang=js&"
export * from "./select_course.vue?vue&type=script&lang=js&"
import style0 from "./select_course.vue?vue&type=style&index=0&id=197c7cfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c7cfe",
  null
  
)

export default component.exports